import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

const container = document.getElementById('root');

const tree = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Nach dem Build enthält das ausgelieferte HTML bereits die fertig gerenderte
// Seite (siehe scripts/prerender.mjs). Dann wird sie nur noch "belebt" statt
// verworfen und neu aufgebaut – der Nutzer sieht den Inhalt sofort, ohne das
// kurze Aufblitzen einer leeren Seite. Im Entwicklungsserver ist #root leer,
// dort greift der normale Weg.
if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(container, tree);
} else {
  ReactDOM.createRoot(container).render(tree);
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

